import {connect} from 'react-redux';
import Restrictions from './Restrictions.jsx';
import {formValueSelector} from 'redux-form';
import {
  handleSave,
  handleCancel,
  validate
} from './actions';

const selector = formValueSelector('tournamentRestrictions');

const mapStateToProps = state => ({
  enforceMinimumCaptainAge: selector(state,'enforceMinimumCaptainAge'),
  requireRosterBeforeCheckout: selector(state, 'requireRosterBeforeCheckout'),
  restrictBowlersToActiveMembership: selector(state,'restrictBowlersToActiveMembership'),
  restrictBowlersToYouthMembership: selector(state, 'restrictBowlersToYouthMembership'),
  blockFailedDivisionCalculation: selector(state, 'blockFailedDivisionCalculation'),
  validate: validate,
  readOnly: state.tournament.base.tournamentInfo.readOnly,
  termsUrl: selector(state,'termsUrl')
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(handleSave(data)),
  onCancel: () => dispatch(handleCancel())
});

export default connect(mapStateToProps, mapDispatchToProps)(Restrictions);



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/RestrictionsContainer.jsx